export const changePasswordResultSelector = (state) => {
    return state.changePassword.records.result;
};
